import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import { style } from './style';

export const HistoryNoResultsMessage = ():JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Box sx={ style.wrapper.sx }>
      <Typography variant="subtitle1">
        {translate(STRING_KEYS.HISTORY_ERROR_MESSAGE_TITLE)}
      </Typography>
      <Typography variant="body2">
        {translate(STRING_KEYS.HISTORY_ERROR_MESSAGE_TEXT)}
      </Typography>
    </Box>
  );
};
